<template>
  <div class="channelConsultReport">
    <!-- <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <reportType :wayString="wayString" :placehold="placehold" :Title="Title"></reportType>
      </el-main>
    </PageNav> -->
    <reportPageTemp
      ref="reportPageTemp"
      :reportParams="reportParams"
      :filter="filter"
    >
      <div class="flex-wrap">
        <div class="flex-al mb10 mr10">
          <!-- <span class="mr10 fs14 color-666">名单登记时间：</span> -->
          <div class="time-box flex-al fs14">
            <el-date-picker
              style="width: 300px"
              v-model="filterList.rangeTime"
              type="daterange"
              @change="search"
              :range-separator="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fmf00')
              "
              value-format="yyyy-MM-dd"
              :start-placeholder="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fmzw0')
              "
              :end-placeholder="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fnis0')
              "
              :picker-options="pickerOptions"
            ></el-date-picker>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              v-model="filter.coursetype_id"
              clearable
              filterable
              :placeholder="
                $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
              "
              @change="filterCourseCat"
            >
              <el-option
                v-for="(item, index) in filterList.coursetypeList"
                :key="index"
                :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                :value="item.coursetype_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.coursecat_id"
              clearable
              filterable
              :placeholder="$t('Customersmanage.dac')"
              @change="search"
            >
              <el-option
                v-for="(item, index) in filterList.courseCatList"
                :key="index"
                :label="`${item.coursecat_cnname}(${item.coursecat_branch})`"
                :value="item.coursecat_id"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              style="width: 180px"
              @change="(filter.channel_id = ''), getChannelData(), search()"
              v-model="filter.client_source"
              :placeholder="$t('Analysisreport.bd')"
            >
              <el-option
                v-for="item in filterList.SchoolsourceOption"
                :key="item.frommedia_id"
                :label="item.frommedia_name"
                :value="item.frommedia_name"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              style="width: 180px"
              @change="search"
              v-model="filter.channel_id"
              :placeholder="$t('Analysisreport.be')"
            >
              <el-option
                v-for="item in filterList.ChannelOption"
                :key="item.channel_id"
                :label="item.channel_name"
                :value="item.channel_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              style="width: 180px"
              @change="search"
              v-model="filter.client_tracestatus"
              :placeholder="$t('Analysisreport.bf')"
            >
              <!-- 跟踪状态：0待跟踪1持续跟踪2已邀约3已试听4已转正-1已无意向-2无效名单', -->
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8frsw0')
                "
                value="0"
              ></el-option>
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fs700')
                "
                value="1"
              ></el-option>
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fss80')
                "
                value="2"
              ></el-option>
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8ft6c0')
                "
                value="3"
              ></el-option>
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fthw0')
                "
                value="4"
              ></el-option>
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fttw0')
                "
                value="-1"
              ></el-option>
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fu5s0')
                "
                value="-2"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="flex-al mb10 mr10">
          <div class="ipt-box" style="width: 200px">
            <el-input
              v-model="filter.keyword"
              clearable
              placeholder="请输入地推人姓名、工号"
              @clear="search"
              @keyup.enter.native="search"
            ></el-input>
          </div>
          <el-button
            type="primary"
            size="mini"
            class="search-btn fs14"
            @click="search"
          >
            {{ $t("views.Analysisreport.channelCrmDetailReport.51h4yx8fut40") }}
          </el-button>
        </div>
      </div>
    </reportPageTemp>
  </div>
</template>
<script>
// import reportType from "@/components/report/reportType3";
import reportPageTemp from "@/components/report/tableTemplate";
import http from "../analysisreport";
export default {
  name: "analysisreport-channelConsultReport",
  data() {
    return {
      reportParams: {
        wayString: "channelConsult", //传递到子组件的方法名称
        Title: "渠道名单跟踪状况表",
      },
      pickerOptions: {},
      filter: {
        starttime: "",
        endtime: "",
        keyword: "",
        client_source: "",
        client_tracestatus: "",
        channel_id: "",
        coursetype_id: "",
        coursecat_id: "",
      },
      filterList: {
        rangeTime: "",
        SchoolsourceOption: [],
        ChannelOption: [], // 招生渠道明细
        coursetypeList: [],
        courseCatList: [],
      },
    };
  },
  components: {
    reportPageTemp,
  },
  created() {
    this.filterList.rangeTime = [
      this.$Common.getAppointedDate(2, 0).startDate,
      this.$Common.getAppointedDate(2, 0).endDate,
    ];
    this.filter.starttime = this.$Common.getAppointedDate(2, 0).startDate;
    this.filter.endtime = this.$Common.getAppointedDate(2, 0).endDate;
    this.getSourceData();
    this.getChannelData();
    this.courseTypeRecruitApi();
    this.getTypeCourseCatApi();
  },
  methods: {
    //下拉列表->获取班组列表--zjb
    courseTypeRecruitApi() {
      this.$http
        .courseTypeRecruitApi({
          coursetype_isrecruit: 1,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.filterList.coursetypeList = res.data.data.list;
          } else {
            this.filterList.coursetypeList = [];
          }
        });
    },
    filterCourseCat() {
      this.filter.coursecat_id = "";
      this.getTypeCourseCatApi();
      this.search();
    },
    getTypeCourseCatApi() {
      this.$http
        .getTypeCourseCatApi({
          coursetype_id: this.filter.coursetype_id,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.filterList.courseCatList = data.list;
          } else {
            this.filterList.courseCatList = [];
          }
        });
    },
    //获取招生渠道类型
    getSourceData() {
      http.getSource({}).then((res) => {
        this.filterList.SchoolsourceOption = res.data.data.list;
      });
    },
    //获取招生渠道明细
    getChannelData() {
      http
        .getChannel({
          channel_medianame: this.filter.client_source,
        })
        .then((res) => {
          this.filterList.ChannelOption = res.data.data.list;
        });
    },
    search() {
      this.filter.starttime = this.filterList.rangeTime
        ? this.filterList.rangeTime[0]
        : "";
      this.filter.endtime = this.filterList.rangeTime
        ? this.filterList.rangeTime[1]
        : "";
      this.$refs["reportPageTemp"].search();
    },
  },
};
</script>
<style lang="less">
@import url("../../../assets/less/manage.less");
@import url("../analysisreport.less");
.channelConsultReport {
  // height: 100vh;
  font-size: 20px;
}
</style>
